/*@ngInject*/
const UIDeleteDataItemsAndGroupsDirective = function ($rootScope, $document) {

    var linkFunction = function ($scope, $elm, $attr) {

        function onKeydown(event) {
            if (event.keyCode === 46) { // Delete key
                $scope.handleDeleteKeyEventAction();
            }
        }

        $document.on('keydown.uiDeleteDataItemsAndGroups', onKeydown);

        $scope.$on('$destroy', function () {
            $document.off('keydown.uiDeleteDataItemsAndGroups', onKeydown);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('uiDeleteDataItemsAndGroups', UIDeleteDataItemsAndGroupsDirective);
